var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckingsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 238,
    viewBox: "0 0 312 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_68645)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M257.288 34.8466C257.288 34.8466 233.126 2.55733 193.059 0.284598C152.991 -1.98813 130.685 25.2921 114.323 45.7542C97.9607 66.2163 48.2747 54.404 18.222 85.7812C-11.8306 117.158 2.74289 135.348 15.9765 153.537C29.2102 171.726 41.9273 174.47 41.9273 189.467C41.9273 204.464 49.2028 224.485 77.8707 229.031C106.539 233.576 136.15 205.855 156.636 216.321C177.123 226.788 211.502 234.967 232.557 229.031C253.613 223.095 247.243 201.287 269.983 194.013C292.723 186.738 314.609 163.996 311.42 139.437C308.232 114.878 290.021 110.325 282.281 86.6783C274.541 63.0314 263.636 44.8496 257.288 34.8466Z",
    fill: "url(#paint0_linear_631_68645)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M284.683 234.151C284.683 235.475 242.766 236.544 191.119 236.544C139.472 236.544 97.5557 235.475 97.5557 234.151C97.5557 232.828 139.472 231.767 191.119 231.767C242.766 231.767 284.683 232.828 284.683 234.151Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.662 12.4248H122.75C120.013 12.4248 117.795 14.6406 117.795 17.374V51.6967C117.795 54.4301 120.013 56.6459 122.75 56.6459H210.662C213.399 56.6459 215.618 54.4301 215.618 51.6967V17.374C215.618 14.6406 213.399 12.4248 210.662 12.4248Z",
    fill: "url(#paint1_linear_631_68645)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M210.662 12.4248H122.75C120.013 12.4248 117.795 14.6406 117.795 17.374V51.6967C117.795 54.4301 120.013 56.6459 122.75 56.6459H210.662C213.399 56.6459 215.618 54.4301 215.618 51.6967V17.374C215.618 14.6406 213.399 12.4248 210.662 12.4248Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.795 48.8701V64.8382L126.709 54.5816",
    fill: "url(#paint2_linear_631_68645)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.066 36.6843H129.922C129.69 36.6843 129.46 36.6387 129.246 36.55C129.031 36.4614 128.837 36.3314 128.673 36.1676C128.509 36.0037 128.379 35.8092 128.29 35.5952C128.201 35.3811 128.155 35.1517 128.155 34.92C128.155 34.6886 128.201 34.4596 128.29 34.2459C128.379 34.0323 128.509 33.8383 128.673 33.675C128.837 33.5118 129.032 33.3825 129.246 33.2947C129.461 33.2068 129.69 33.1621 129.922 33.1631H193.066C193.297 33.1631 193.526 33.2085 193.739 33.2968C193.952 33.3851 194.146 33.5145 194.31 33.6777C194.473 33.8408 194.603 34.0345 194.691 34.2477C194.779 34.4608 194.825 34.6893 194.825 34.92C194.825 35.3866 194.64 35.8343 194.31 36.1649C193.981 36.4956 193.533 36.6824 193.066 36.6843Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.066 44.7888H129.922C129.69 44.7888 129.46 44.7432 129.246 44.6545C129.031 44.5659 128.837 44.4359 128.673 44.2721C128.509 44.1082 128.379 43.9137 128.29 43.6997C128.201 43.4856 128.155 43.2562 128.155 43.0245C128.155 42.7931 128.201 42.5641 128.29 42.3504C128.379 42.1368 128.509 41.9428 128.673 41.7795C128.837 41.6163 129.032 41.487 129.246 41.3992C129.461 41.3113 129.69 41.2666 129.922 41.2676H193.066C193.297 41.2676 193.526 41.313 193.739 41.4013C193.952 41.4896 194.146 41.619 194.31 41.7822C194.473 41.9453 194.603 42.139 194.691 42.3521C194.779 42.5653 194.825 42.7938 194.825 43.0245C194.825 43.4911 194.64 43.9388 194.31 44.2694C193.981 44.6001 193.533 44.7869 193.066 44.7888Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.446 28.5811C136.951 28.5811 139.793 25.7429 139.793 22.2417C139.793 18.7406 136.951 15.9023 133.446 15.9023C129.94 15.9023 127.099 18.7406 127.099 22.2417C127.099 25.7429 129.94 28.5811 133.446 28.5811Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M210.662 72.2695H122.75C120.013 72.2695 117.795 74.4853 117.795 77.2187V111.541C117.795 114.275 120.013 116.491 122.75 116.491H210.662C213.399 116.491 215.618 114.275 215.618 111.541V77.2187C215.618 74.4853 213.399 72.2695 210.662 72.2695Z",
    fill: "url(#paint3_linear_631_68645)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M210.662 72.2695H122.75C120.013 72.2695 117.795 74.4853 117.795 77.2187V111.541C117.795 114.275 120.013 116.491 122.75 116.491H210.662C213.399 116.491 215.618 114.275 215.618 111.541V77.2187C215.618 74.4853 213.399 72.2695 210.662 72.2695Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.795 108.709V124.677L126.709 114.42",
    fill: "url(#paint4_linear_631_68645)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M117.795 108.709V124.677L126.709 114.42",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M193.066 96.5242H129.922C129.69 96.5252 129.461 96.4805 129.246 96.3926C129.032 96.3048 128.837 96.1755 128.673 96.0123C128.509 95.849 128.379 95.655 128.29 95.4414C128.201 95.2277 128.155 94.9987 128.155 94.7673C128.154 94.5353 128.199 94.3055 128.288 94.0909C128.376 93.8764 128.506 93.6815 128.67 93.5175C128.835 93.3535 129.03 93.2236 129.245 93.1352C129.459 93.0469 129.69 93.002 129.922 93.0029H193.066C193.298 93.0029 193.527 93.0486 193.741 93.1374C193.955 93.2262 194.149 93.3562 194.312 93.5202C194.476 93.6841 194.605 93.8787 194.693 94.0927C194.781 94.3067 194.826 94.536 194.825 94.7673C194.825 94.998 194.779 95.2265 194.691 95.4396C194.603 95.6528 194.473 95.8465 194.31 96.0096C194.146 96.1727 193.953 96.3022 193.739 96.3904C193.526 96.4787 193.297 96.5242 193.066 96.5242Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M193.066 104.629H129.922C129.69 104.63 129.461 104.585 129.246 104.497C129.032 104.409 128.837 104.28 128.673 104.117C128.509 103.954 128.379 103.76 128.29 103.546C128.201 103.332 128.155 103.103 128.155 102.872C128.154 102.64 128.199 102.41 128.288 102.195C128.376 101.981 128.506 101.786 128.67 101.622C128.835 101.458 129.03 101.328 129.245 101.24C129.459 101.151 129.69 101.106 129.922 101.107H193.066C193.298 101.107 193.527 101.153 193.741 101.242C193.955 101.331 194.149 101.461 194.312 101.625C194.476 101.789 194.605 101.983 194.693 102.197C194.781 102.411 194.826 102.64 194.825 102.872C194.825 103.103 194.779 103.331 194.691 103.544C194.603 103.757 194.473 103.951 194.31 104.114C194.146 104.277 193.953 104.407 193.739 104.495C193.526 104.583 193.297 104.629 193.066 104.629Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M133.446 88.4181C136.951 88.4181 139.793 85.5798 139.793 82.0787C139.793 78.5775 136.951 75.7393 133.446 75.7393C129.94 75.7393 127.099 78.5775 127.099 82.0787C127.099 85.5798 129.94 88.4181 133.446 88.4181Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.864 159.892C49.7967 159.892 49.4973 155.205 49.5123 154.906C49.6844 151.445 52.0645 144.851 55.8219 143.85C56.4507 143.701 57.1038 143.686 57.7388 143.805C58.3739 143.925 58.9767 144.176 59.5081 144.544C60.0395 144.911 60.4877 145.386 60.8236 145.937C61.1595 146.488 61.3756 147.104 61.4578 147.744C61.892 150.451 60.1256 153.336 58.3292 155.22C56.226 157.403 49.864 159.892 49.864 159.892Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9523 141.836C44.8774 141.836 45.2966 137.148 45.3565 136.849C46.06 133.455 49.4132 127.295 53.2753 126.877C53.9194 126.824 54.5674 126.907 55.1771 127.121C55.7869 127.335 56.3446 127.675 56.8142 128.119C57.2837 128.562 57.6544 129.1 57.9023 129.696C58.1501 130.292 58.2695 130.934 58.2526 131.579C58.2526 134.322 56.0895 136.909 54.0312 138.486C51.6211 140.34 44.9523 141.828 44.9523 141.836Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7091 120.516C43.6343 120.516 44.0534 115.836 44.1133 115.537C44.8169 112.143 48.17 105.983 52.0321 105.564C52.6762 105.511 53.3242 105.595 53.934 105.809C54.5437 106.023 55.1015 106.363 55.571 106.806C56.0405 107.25 56.4113 107.787 56.6591 108.383C56.9069 108.98 57.0263 109.621 57.0094 110.266C57.0094 113.01 54.8464 115.597 52.7955 117.174C50.378 119.02 43.7091 120.516 43.7091 120.516Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5617 100.472C41.4868 100.472 41.9059 95.7844 41.9658 95.4928C42.6694 92.0914 46.0225 85.9389 49.8846 85.5128C50.5292 85.4612 51.1773 85.5456 51.7871 85.7604C52.3968 85.9753 52.9545 86.3159 53.4238 86.76C53.8932 87.2042 54.2638 87.742 54.5116 88.3385C54.7593 88.935 54.8787 89.5769 54.862 90.2225C54.862 92.966 52.6989 95.5452 50.6481 97.1225C48.2305 98.9765 41.5617 100.472 41.5617 100.472Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.161 84.3607C35.1011 84.3607 34.2554 79.7482 34.2404 79.4492C34.0158 75.9879 35.6176 69.1626 39.2402 67.7422C39.8472 67.5209 40.4941 67.4299 41.1387 67.4752C41.7833 67.5205 42.4111 67.7011 42.9811 68.0051C43.5511 68.3092 44.0505 68.7299 44.4467 69.2398C44.8428 69.7497 45.1269 70.3373 45.2803 70.9642C46.0288 73.6031 44.6067 76.6682 43.0349 78.739C41.2012 81.1611 35.1685 84.3607 35.161 84.3607Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9007 159.945C47.9681 159.945 45.9248 155.676 45.7676 155.422C43.9189 152.492 38.6122 147.902 34.8474 148.866C34.2274 149.044 33.6518 149.351 33.1579 149.765C32.664 150.18 32.2629 150.693 31.9806 151.273C31.6983 151.852 31.5412 152.484 31.5193 153.128C31.4974 153.773 31.6112 154.414 31.8535 155.011C32.7966 157.59 35.7531 159.242 38.2305 159.997C41.1271 160.887 47.8932 159.945 47.9007 159.945Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9625 139.415C44.0299 139.415 41.3653 135.497 41.1707 135.273C38.9253 132.649 32.9375 128.919 29.3748 130.436C28.7879 130.705 28.264 131.094 27.837 131.577C27.41 132.061 27.0895 132.629 26.8962 133.244C26.7028 133.859 26.641 134.508 26.7147 135.149C26.7884 135.789 26.996 136.407 27.324 136.963C28.6488 139.37 31.8148 140.551 34.3821 140.925C37.3984 141.373 43.9625 139.415 43.9625 139.415Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8178 119.311C42.8851 119.311 40.2206 115.394 40.026 115.162C37.7806 112.538 31.7928 108.808 28.2301 110.333C27.6426 110.602 27.1184 110.991 26.6915 111.476C26.2647 111.961 25.9449 112.53 25.7528 113.146C25.5608 113.763 25.5009 114.412 25.5769 115.053C25.653 115.694 25.8633 116.312 26.1942 116.867C27.519 119.266 30.6851 120.455 33.2523 120.829C36.2686 121.262 42.8103 119.311 42.8178 119.311Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M40.878 100.854C40.9454 100.854 38.2808 96.9369 38.0862 96.7126C35.8408 94.0886 29.8531 90.3583 26.2903 91.8758C25.7036 92.1457 25.1803 92.5357 24.7541 93.0205C24.328 93.5053 24.0086 94.0742 23.8167 94.6902C23.6247 95.3062 23.5645 95.9556 23.6399 96.5964C23.7154 97.2371 23.9247 97.8549 24.2545 98.4096C25.5793 100.817 28.7453 101.998 31.3126 102.372C34.3289 102.813 40.8706 100.854 40.878 100.854Z",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1964 84.9672C35.2638 84.9672 32.2025 81.364 31.963 81.1546C29.4107 78.7998 23.1011 75.7422 19.7105 77.6485C19.1548 77.9804 18.6754 78.4257 18.3037 78.9553C17.932 79.4849 17.6763 80.0868 17.5534 80.7218C17.4305 81.3568 17.4431 82.0105 17.5904 82.6403C17.7377 83.2701 18.0164 83.8618 18.4082 84.3767C19.9875 86.6194 23.2658 87.4567 25.8929 87.5464C28.9018 87.6211 35.1889 84.9747 35.1964 84.9672Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0321 71.8383C27.0995 71.8383 26.0217 67.2483 25.9169 66.9642C24.7418 63.6973 20.5503 58.083 16.6658 58.2101C16.0207 58.2493 15.3911 58.4236 14.8179 58.7219C14.2448 59.0202 13.741 59.4356 13.3392 59.9413C12.9375 60.4469 12.6468 61.0313 12.4862 61.6566C12.3256 62.2818 12.2986 62.9339 12.407 63.5702C12.7737 66.2914 15.3036 68.5341 17.5639 69.8049C20.2135 71.3001 27.0246 71.8383 27.0321 71.8383Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4044 184.116C56.4044 184.116 55.6034 182.284 54.3385 179.077C53.0735 175.87 51.3444 171.242 49.5106 165.62C48.5899 162.809 47.6468 159.744 46.7411 156.477C46.277 154.832 45.8579 153.18 45.3938 151.408C45.2067 150.541 45.012 149.666 44.8174 148.784C44.6228 147.902 44.4956 146.967 44.3309 146.048C43.7501 142.276 43.3778 138.474 43.2156 134.662C43.021 130.781 42.9462 126.857 42.8563 122.932C42.7665 119.007 42.6542 115.097 42.3474 111.269C42.0744 107.52 41.5341 103.794 40.7306 100.122C39.9143 96.701 38.7971 93.3587 37.3922 90.1339C36.1326 87.2218 34.703 84.386 33.1108 81.6411C31.6736 79.0843 30.1916 76.8265 28.8667 74.8378C27.5419 72.8492 26.2919 71.1746 25.2514 69.8363C23.1706 67.1076 21.8682 65.6348 21.8682 65.6348C21.8682 65.6348 23.2005 67.0777 25.3412 69.7616C26.4116 71.1147 27.6766 72.752 29.0838 74.7257C30.491 76.6994 31.988 78.9198 33.485 81.4542C35.1464 84.167 36.646 86.9755 37.9761 89.8648C39.4761 93.0974 40.6836 96.4576 41.5839 99.9052C42.4732 103.594 43.101 107.342 43.4626 111.119C43.8593 114.984 44.054 118.917 44.2111 122.842C44.3683 126.767 44.5405 130.684 44.8174 134.52C45.0664 138.257 45.5212 141.979 46.1797 145.666C46.3594 146.556 46.4791 147.423 46.7112 148.305C46.9432 149.188 47.1378 150.055 47.3474 150.915C47.8115 152.559 48.2755 154.256 48.7696 155.849C49.7426 159.056 50.7381 162.076 51.7112 164.82C53.6424 170.352 55.4537 174.883 56.7786 178.038C58.1035 181.193 58.9343 183.002 58.9343 183.002C59.0577 183.325 59.0539 183.683 58.9236 184.004C58.7933 184.324 58.5463 184.584 58.2322 184.73C57.9181 184.876 57.5604 184.897 57.2309 184.79C56.9015 184.683 56.6249 184.456 56.4567 184.153V184.116H56.4044Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0324 155.138C73.965 155.138 75.0129 150.54 75.1177 150.256C76.2703 146.989 80.4318 141.345 84.3164 141.45C84.9618 141.485 85.5925 141.656 86.1675 141.951C86.7424 142.246 87.2486 142.659 87.6532 143.163C88.0578 143.666 88.3517 144.249 88.5157 144.874C88.6797 145.498 88.7102 146.15 88.6051 146.787C88.2533 149.501 85.7385 151.766 83.4856 153.052C80.8435 154.562 74.0399 155.138 74.0324 155.138Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4652 136.432C74.3904 136.432 76.1343 132.036 76.269 131.774C77.9082 128.709 82.878 123.761 86.7027 124.456C87.3354 124.588 87.933 124.852 88.4568 125.23C88.9807 125.608 89.4189 126.092 89.743 126.651C90.067 127.209 90.2697 127.83 90.3378 128.472C90.4059 129.113 90.3379 129.763 90.1382 130.377C89.3897 133.015 86.5455 134.862 84.1504 135.796C81.2838 136.888 74.4652 136.432 74.4652 136.432Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3388 115.641C79.2715 115.641 81.0079 111.246 81.1501 110.984C82.7893 107.926 87.7516 102.978 91.5838 103.665C92.216 103.799 92.813 104.065 93.336 104.444C93.859 104.823 94.2963 105.308 94.6195 105.867C94.9428 106.426 95.1447 107.047 95.2123 107.689C95.2799 108.331 95.2116 108.98 95.0118 109.594C94.2633 112.225 91.4266 114.079 89.024 115.013C86.1574 116.105 79.3463 115.641 79.3388 115.641Z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9834 95.843C82.916 95.843 84.6524 91.4473 84.7947 91.1781C86.4338 88.1206 91.3962 83.1716 95.2283 83.8669C95.8603 83.9999 96.4572 84.2643 96.9801 84.6429C97.5031 85.0214 97.9404 85.5056 98.2637 86.064C98.5871 86.6225 98.7891 87.2426 98.8567 87.8841C98.9244 88.5256 98.8561 89.1742 98.6563 89.7877C97.9079 92.4266 95.0712 94.2731 92.6686 95.2075C89.8094 96.2691 82.9908 95.843 82.9834 95.843Z",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4348 78.5513C81.3674 78.5513 81.8838 73.8715 81.9512 73.58C82.6997 70.1935 86.2025 64.1083 90.0796 63.7719C90.7244 63.7334 91.3701 63.8309 91.9747 64.058C92.5793 64.2851 93.1293 64.6368 93.5889 65.0902C94.0485 65.5436 94.4074 66.0885 94.6422 66.6896C94.8771 67.2906 94.9827 67.9343 94.9521 68.5787C94.9147 71.3223 92.7067 73.8566 90.5885 75.3891C88.1261 77.1908 81.4422 78.5439 81.4348 78.5513Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1365 154.63C72.2114 154.63 71.4629 149.98 71.3881 149.696C70.4525 146.354 66.6727 140.448 62.7807 140.299C62.1371 140.297 61.5002 140.43 60.9112 140.689C60.3222 140.948 59.7941 141.327 59.3611 141.803C58.928 142.278 58.5996 142.839 58.397 143.449C58.1945 144.059 58.1223 144.705 58.185 145.345C58.3572 148.081 60.7149 150.503 62.878 151.931C65.3778 153.613 72.1365 154.63 72.1365 154.63Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1944 133.829C74.2618 133.829 72.8172 129.344 72.6975 129.06C71.2679 125.898 66.6349 120.635 62.7728 121.076C62.1301 121.163 61.5133 121.385 60.9626 121.728C60.4119 122.07 59.9398 122.524 59.5773 123.061C59.2147 123.599 58.97 124.206 58.8589 124.844C58.7479 125.483 58.7732 126.137 58.9331 126.765C59.5169 129.441 62.2114 131.482 64.5691 132.566C67.3609 133.844 74.1869 133.829 74.1944 133.829Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8283 114.227C78.9031 114.227 77.4586 109.742 77.3313 109.458C75.8943 106.303 71.2687 101.04 67.3991 101.481C66.7594 101.571 66.146 101.795 65.5988 102.138C65.0516 102.481 64.583 102.936 64.2235 103.472C63.864 104.008 63.6218 104.614 63.5125 105.25C63.4032 105.886 63.4294 106.538 63.5894 107.163C64.1732 109.846 66.8752 111.88 69.2329 112.971C71.9947 114.242 78.8283 114.227 78.8283 114.227Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2277 95.986C82.295 95.986 80.8505 91.5006 80.7307 91.2165C79.2937 88.0617 74.6606 82.7989 70.7985 83.2399C70.1589 83.3302 69.5454 83.5541 68.9982 83.8971C68.4511 84.2401 67.9824 84.6945 67.623 85.2307C67.2635 85.7668 67.0212 86.3726 66.9119 87.0085C66.8026 87.6445 66.8289 88.2963 66.9888 88.9215C67.5726 91.6052 70.2746 93.6386 72.6248 94.7226C75.4016 96.001 82.2202 95.986 82.2277 95.986Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2981 79.1432C81.3655 79.1432 79.4344 74.8297 79.2847 74.568C77.5108 71.5777 72.3314 66.8606 68.5367 67.7278C67.9111 67.8891 67.3264 68.1801 66.8206 68.5817C66.3148 68.9833 65.8992 69.4866 65.6007 70.0589C65.3021 70.6313 65.1274 71.2599 65.0878 71.9041C65.0482 72.5482 65.1445 73.1935 65.3706 73.798C66.2464 76.3921 69.1579 78.1265 71.6204 78.9413C74.5095 79.9057 81.2906 79.1432 81.2981 79.1432Z",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2046 64.2353C77.272 64.2353 77.5414 59.5481 77.5264 59.2491C77.3318 55.7803 74.9143 49.2017 71.1495 48.2224C70.5199 48.0772 69.8667 48.066 69.2325 48.1895C68.5982 48.3131 67.9972 48.5687 67.4683 48.9396C66.9395 49.3105 66.4948 49.7885 66.1632 50.3424C65.8315 50.8963 65.6204 51.5138 65.5434 52.1546C65.1168 54.8683 66.8982 57.739 68.7095 59.6303C70.8276 61.7833 77.2046 64.2279 77.2046 64.2353Z",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4185 180.219C73.4185 180.219 73.164 178.238 72.8721 174.799C72.5802 171.36 72.2209 166.441 72.0712 160.527C71.9889 157.537 71.9589 154.367 72.0188 150.973C72.0188 149.268 72.1011 147.564 72.1685 145.74C72.2359 144.858 72.2957 143.968 72.3631 143.063C72.4305 142.159 72.5727 141.232 72.67 140.305C73.1791 136.53 73.8962 132.786 74.8182 129.09C75.7314 125.352 76.7793 121.525 77.8123 117.742C78.8452 113.959 79.8482 110.176 80.6416 106.415C81.4451 102.743 81.9878 99.0178 82.2659 95.2686C82.4585 91.7586 82.3383 88.2385 81.9066 84.7498C81.5308 81.6126 80.9735 78.4998 80.2374 75.4271C79.5862 72.5637 78.8153 69.977 78.1042 67.6968C77.3931 65.4166 76.682 63.4578 76.0757 61.8505C74.8631 58.6358 74.0248 56.8564 74.0248 56.8564C74.0248 56.8564 74.9006 58.6208 76.188 61.8056C76.8242 63.398 77.5727 65.3493 78.3437 67.6145C79.1147 69.8798 79.938 72.4591 80.6566 75.3224C81.4648 78.3982 82.0921 81.5185 82.5353 84.6675C83.0479 88.1917 83.2458 91.7543 83.1267 95.3135C82.9341 99.1152 82.4663 102.898 81.727 106.632C80.9784 110.445 80.0802 114.273 79.1371 118.086C78.194 121.898 77.2209 125.696 76.3976 129.449C75.5724 133.106 74.9477 136.804 74.5263 140.529C74.4515 141.433 74.3167 142.293 74.2868 143.205C74.2568 144.117 74.197 145.007 74.152 145.889C74.152 147.594 74.0997 149.358 74.152 151.025C74.152 154.382 74.2643 157.552 74.4065 160.475C74.691 166.329 75.155 171.196 75.5068 174.59C75.8586 177.984 76.1581 179.898 76.1581 179.898C76.1841 180.075 76.1749 180.256 76.1311 180.429C76.0873 180.603 76.0096 180.767 75.9026 180.91C75.7956 181.054 75.6612 181.175 75.5073 181.267C75.3533 181.359 75.1828 181.42 75.0053 181.446C74.8279 181.472 74.6471 181.462 74.4732 181.419C74.2993 181.375 74.1358 181.297 73.9919 181.19C73.848 181.083 73.7266 180.949 73.6347 180.796C73.5427 180.642 73.482 180.471 73.4559 180.294L73.4185 180.219Z",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1017 229.658H50.4099L41.4951 177.812H91.009L82.1017 229.658Z",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M137.922 234.552C175.983 234.552 206.837 203.735 206.837 165.72C206.837 127.705 175.983 96.8877 137.922 96.8877C99.8612 96.8877 69.0068 127.705 69.0068 165.72C69.0068 203.735 99.8612 234.552 137.922 234.552Z",
    fill: "url(#paint5_linear_631_68645)",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M119.664 210.975C113.835 208.826 108.491 205.54 103.946 201.308C99.358 196.908 95.8046 191.546 93.5415 185.608C90.9737 178.95 89.7034 171.862 89.799 164.728C89.7535 158.638 90.8293 152.591 92.9726 146.89C94.9194 141.663 97.826 136.846 101.543 132.685C108.896 124.642 118.395 118.864 128.923 116.028C134.096 114.642 139.429 113.939 144.784 113.935C149.226 113.918 153.653 114.445 157.966 115.505C162.138 116.532 166.131 118.186 169.807 120.409C173.439 122.586 176.693 125.338 179.44 128.558C182.322 132.024 184.519 136.004 185.915 140.288C187.531 145.165 188.328 150.276 188.273 155.412C188.219 165.296 184.672 174.844 178.258 182.371C175.491 185.534 172.199 188.197 168.527 190.243C165.379 192.09 161.81 193.101 158.16 193.182C155.654 193.216 153.206 192.428 151.192 190.939C150.172 190.193 149.343 189.219 148.769 188.094C148.196 186.97 147.895 185.726 147.891 184.464C143.614 190.475 137.833 193.481 130.548 193.481C124.62 193.481 119.879 191.457 116.326 187.41C112.773 183.363 111.007 178.379 111.027 172.458C111.044 167.957 111.828 163.492 113.347 159.255C114.834 154.971 116.964 150.938 119.664 147.293C122.345 143.699 125.768 140.724 129.702 138.569C133.625 136.355 138.056 135.196 142.561 135.204C145.691 135.176 148.779 135.929 151.543 137.395C154.236 138.82 156.417 141.046 157.786 143.765L158.377 141.866C158.631 141.045 159.08 140.299 159.685 139.689C160.289 139.079 161.033 138.624 161.851 138.363C162.67 138.101 163.54 138.041 164.387 138.188C165.234 138.334 166.033 138.683 166.716 139.204C167.151 139.556 167.497 140.005 167.724 140.516C167.952 141.027 168.055 141.584 168.026 142.142C168.023 142.676 167.934 143.206 167.764 143.712L158.482 174.559C157.434 178.087 156.91 180.507 156.91 181.818C156.91 184.036 158.045 185.145 160.316 185.145C163.28 185.145 166.189 183.784 169.044 181.063C172.127 177.995 174.505 174.293 176.012 170.215C177.79 165.755 178.7 160.998 178.692 156.197C178.734 151.957 178.11 147.737 176.843 143.69C175.78 140.205 174.097 136.941 171.873 134.053C169.778 131.419 167.246 129.163 164.388 127.384C161.538 125.589 158.428 124.245 155.166 123.4C151.811 122.54 148.36 122.113 144.897 122.129C140.504 122.132 136.133 122.746 131.91 123.953C127.581 125.195 123.457 127.059 119.664 129.485C115.832 131.903 112.362 134.85 109.357 138.24C106.25 141.827 103.832 145.955 102.224 150.418C100.436 155.249 99.5386 160.363 99.5745 165.513C99.481 171.628 100.592 177.701 102.845 183.388C104.774 188.319 107.835 192.729 111.783 196.262C115.583 199.571 119.977 202.131 124.732 203.805C129.742 205.577 135.023 206.462 140.338 206.422C146.017 206.432 151.664 205.573 157.082 203.872C157.632 203.688 158.209 203.599 158.789 203.611C159.338 203.588 159.885 203.685 160.393 203.894C160.901 204.103 161.357 204.42 161.731 204.822C162.446 205.568 162.843 206.562 162.838 207.595C162.91 208.426 162.678 209.255 162.185 209.928C161.693 210.601 160.973 211.074 160.159 211.259C153.394 213.325 146.365 214.403 139.29 214.459C132.591 214.499 125.94 213.318 119.664 210.975ZM143.317 181.31C146.14 179.276 148.239 176.395 149.305 173.086L155.293 152.048L154.904 151.196C154.523 150.501 154.061 149.853 153.527 149.267C152.814 148.446 152.038 147.681 151.207 146.979C150.133 146.118 148.913 145.455 147.606 145.021C144.22 143.824 140.505 143.953 137.209 145.379C135.415 146.153 133.765 147.225 132.329 148.549C130.839 149.942 129.513 151.499 128.377 153.192C127.185 154.943 126.181 156.815 125.383 158.777C124.576 160.731 123.952 162.756 123.519 164.825C123.09 166.79 122.869 168.794 122.861 170.806C122.853 172.095 122.93 173.384 123.093 174.663C123.232 175.797 123.482 176.913 123.841 177.998C124.16 178.979 124.61 179.912 125.181 180.771C125.716 181.565 126.381 182.263 127.15 182.835C127.967 183.428 128.885 183.869 129.859 184.135C131.009 184.457 132.198 184.613 133.392 184.599C136.972 184.635 140.463 183.483 143.317 181.324V181.31Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M231.644 107.805C231.644 107.805 229.399 111.976 229.07 112.559C228.74 113.142 227.535 116.297 227.887 117.045C228.239 117.792 228.598 118.218 229.302 118.338C230.005 118.458 230.596 119.751 231.779 119.983C232.519 120.129 233.27 120.209 234.024 120.222C234.208 120.356 234.421 120.447 234.645 120.487C234.869 120.528 235.1 120.516 235.319 120.454C236.03 120.222 236.622 119.87 237.093 117.867C237.375 116.874 237.454 115.834 237.325 114.809L237.078 110.795L231.644 107.805Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M244.615 220.163C244.615 220.163 241.419 225.396 241.419 226.622C241.419 227.848 245.828 230.181 247.714 231.018C249.6 231.856 252.953 232.514 255.678 232.902C258.403 233.291 264.061 234.398 262.415 232.274C260.768 230.151 250.678 224.529 250.259 223.901C249.737 223.277 249.153 222.709 248.515 222.204L244.615 220.163Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M249.628 228.347L250.743 230.022C251.954 231.848 253.593 233.352 255.518 234.402C258.512 236.017 263.13 237.864 267.15 236.757C273.759 234.941 257.135 224.931 257.135 224.931C257.135 224.931 251.215 229.027 249.628 228.347Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M251.53 229.143C253.349 231.89 256.104 233.885 259.284 234.757C264.711 236.304 266.26 235.923 267.428 234.368",
    stroke: "#263238",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M241.838 225.656C241.838 225.656 247.826 229.94 250.745 230.022",
    stroke: "#263238",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M228.843 109.298C228.843 109.298 234.15 118.097 235.288 120.138C236.425 122.179 250.774 138.559 256.463 152.659C262.152 166.759 267.616 179.491 267.391 183.58C267.167 187.67 248.484 222.187 248.484 222.187L244.614 220.146C244.614 220.146 250.535 187.625 249.854 184.216C249.173 180.807 228.229 146.925 228.229 146.925C228.229 146.925 218.439 140.107 214.337 132.145",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M229.591 131.256C229.591 131.256 226.634 137.618 226.634 138.53C226.634 139.442 243.251 188.329 248.034 199.468C251.058 206.605 253.716 213.891 255.998 221.298C255.998 221.298 257.817 223.541 256.455 225.844C255.092 228.146 249.628 229.709 248.483 227.66C247.338 225.612 236.193 214.951 231.41 204.245C226.627 193.539 219.8 175.365 215.931 168.547C210.82 159.817 206.258 150.779 202.27 141.483C197.263 129.664 192.105 116.812 192.105 116.812C198.865 117.377 205.669 116.615 212.136 114.57C222.615 111.16 227.106 104.634 227.106 104.634C227.106 104.634 229.77 111.437 230.459 112.76",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M231.15 150.2L225.911 136.587L231.779 131.563",
    stroke: "white",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M236.806 136.168L225.909 136.587C225.909 136.587 225.909 132.4 224.023 129.679C222.136 126.958 221.717 126.539 221.508 125.702C221.395 124.939 221.395 124.163 221.508 123.399",
    stroke: "white",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M250.649 181.819C250.649 181.819 257.565 185.385 262.385 184.967",
    stroke: "white",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M251.905 183.91C251.905 183.91 256.726 187.887 260.887 188.934",
    stroke: "white",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M224.232 121.097C224.023 121.725 225.071 124.655 225.729 126.12C226.388 127.586 228.454 128.632 228.454 129.679C228.454 130.725 225.729 132.609 225.729 132.609",
    stroke: "white",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M206.211 126.539C206.211 126.539 204.953 130.726 202.857 132.4L200.754 134.075",
    stroke: "white",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M197.818 125.702C197.818 125.702 201.381 137.425 206.628 146.433C211.875 155.442 223.844 174.902 224.233 178.67C224.622 182.438 224.233 186.214 227.167 188.098C230.102 189.982 229.892 190.819 230.311 193.331C230.67 195.133 231.232 196.889 231.988 198.564C231.988 198.564 240.371 212.769 243.313 218.002C245.448 221.658 247.868 225.14 250.551 228.416",
    stroke: "white",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M192.105 116.85C192.105 116.85 192.577 122.143 194.673 123.818C196.769 125.492 203.064 126.957 211.657 125.313C220.249 123.668 229.681 116.341 230.519 113.8C231.357 111.258 227.091 104.679 227.091 104.679C227.091 104.679 222.136 111.706 208.303 114.009C194.471 116.312 192.105 116.85 192.105 116.85Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M247.347 65.5408C243.934 63.298 217.302 42.5743 214.794 41.6622C212.287 40.7501 207.309 41.6622 207.309 41.6622C207.309 41.6622 191.882 43.5462 188.641 44.847C188.342 44.9666 181.381 48.9589 181.156 49.1682C178.649 51.2167 167.683 56.2555 164.734 62.6252C161.388 69.8246 190.789 113.216 192.159 116.849C193.529 120.483 200.707 121.38 207.309 120.468C213.911 119.556 219.704 118.225 224.48 112.76C225.352 111.673 226.082 110.48 226.651 109.209C227.334 107.79 227.508 106.18 227.145 104.648C225.43 97.546 221.074 77.069 218.207 63.5298C222.998 66.6099 232.953 72.8824 238.754 75.0953C246.493 78.0857 252.414 76.0074 252.414 73.5029C252.414 70.9984 250.767 67.8136 247.347 65.5408Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_631_68645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 41,
    width: 89,
    height: 80
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M247.349 65.5418C243.936 63.299 217.304 42.5753 214.796 41.6632C212.289 40.7511 207.311 41.6632 207.311 41.6632C207.311 41.6632 191.884 43.5472 188.643 44.848C188.344 44.9676 181.383 48.9599 181.158 49.1692C178.651 51.2176 167.685 56.2565 164.736 62.6262C161.39 69.8256 190.791 113.217 192.161 116.85C193.531 120.484 200.709 121.381 207.311 120.469C213.913 119.557 219.706 118.226 224.482 112.761C225.354 111.674 226.083 110.481 226.652 109.21C227.336 107.791 227.51 106.181 227.146 104.649C225.432 97.547 221.076 77.07 218.209 63.5308C223 66.6109 232.955 72.8833 238.756 75.0963C246.495 78.0867 252.416 76.0084 252.416 73.5039C252.416 70.9994 250.769 67.8146 247.349 65.5418Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_631_68645)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M217.851 58.1416C219.897 58.9008 222.042 59.3592 224.22 59.5023C226.952 59.5023 225.358 60.6386 224.22 61.0947C223.083 61.5507 231.503 60.4143 231.279 61.775C231.054 63.1356 225.104 65.8719 225.104 65.8719C229.097 68.1181 233.514 69.5107 238.075 69.9613C246.047 70.8734 241.069 75.6506 241.069 75.6506C241.069 75.6506 228.255 70.9481 218.157 63.5244L217.851 58.1416Z",
    fill: "url(#paint6_linear_631_68645)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M177.548 73.6025C177.548 73.6025 175.729 76.593 176.642 76.7874C177.556 76.9817 186.882 73.1465 183.693 76.3313C180.505 79.5161 176.642 79.5161 178.229 80.4207C179.816 81.3253 183.925 81.3328 182.556 82.2449C181.186 83.157 183.925 87.2464 190.789 95.4327C197.653 103.619 200.58 109.301 208.095 113.166C215.61 117.031 220.617 117.031 216.059 118.168C211.501 119.304 206.688 119.992 206.463 122.01C206.463 122.01 206.688 123.603 203.956 124.739C201.223 125.875 199.629 125.651 197.586 124.739C195.542 123.827 194.854 123.834 194.397 122.691C193.94 121.547 192.107 116.829 192.107 116.829L188.843 109.862L187.795 108.366L186.882 107.686L170.946 80.3983L177.548 73.6025Z",
    fill: "url(#paint7_linear_631_68645)"
  }))))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M247.347 65.5408C243.934 63.298 217.302 42.5743 214.794 41.6622C212.287 40.7501 207.309 41.6622 207.309 41.6622C207.309 41.6622 191.882 43.5462 188.641 44.847C188.342 44.9666 181.381 48.9589 181.156 49.1682C178.649 51.2167 167.683 56.2555 164.734 62.6252C161.388 69.8247 190.789 113.216 192.159 116.849C193.529 120.483 200.707 121.38 207.309 120.468C213.911 119.556 219.704 118.225 224.48 112.76C225.352 111.673 226.082 110.48 226.651 109.209C227.334 107.79 227.508 106.18 227.145 104.648C225.43 97.546 221.074 77.069 218.207 63.5298C222.998 66.6099 232.953 72.8824 238.754 75.0953C246.493 78.0857 252.414 76.0074 252.414 73.5029C252.414 70.9984 250.767 67.8136 247.347 65.5408Z",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M168.341 57.9678C168.341 57.9678 165.609 60.9582 164.546 62.3413C158.842 69.6679 140.691 93.1129 140.482 95.0043C140.272 96.8958 141.148 98.1667 145.586 99.8713C150.025 101.576 179.711 71.8584 179.711 71.8584",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_631_68645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 57,
    width: 40,
    height: 43
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M168.341 57.9688C168.341 57.9688 165.609 60.9592 164.546 62.3423C158.842 69.6688 140.691 93.1139 140.482 95.0053C140.272 96.8968 141.148 98.1677 145.586 99.8722C150.025 101.577 179.711 71.8593 179.711 71.8593",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_631_68645)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M170.033 57.4619L148.184 87.927C148.184 87.927 150.43 90.4315 153.192 92.9285C155.954 95.4255 160.677 97.0254 157.062 96.7936C153.446 96.5619 146.582 93.8032 146.582 93.8032C146.582 93.8032 144.532 95.3956 147.039 96.988C149.547 98.5804 149.996 97.4366 157.279 101.077C164.562 104.718 176.223 107.058 176.223 107.058L175.28 108.972L144.307 101.07C144.307 101.07 139.816 98.8271 140.46 95.0891C141.103 91.351 151.553 79.3893 151.553 79.3893L166.523 59.7945C166.523 59.7945 167.93 57.7535 170.033 57.4619Z",
    fill: "url(#paint8_linear_631_68645)"
  }))))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M168.341 57.9678C168.341 57.9678 165.609 60.9582 164.546 62.3413C158.842 69.6679 140.691 93.1129 140.482 95.0043C140.272 96.8958 141.148 98.1667 145.586 99.8713C150.025 101.576 179.711 71.8584 179.711 71.8584",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M228.422 56.6084L218.153 63.5234C219.65 63.3141 226.746 60.7948 226.746 60.7948",
    stroke: "#263238",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M228.006 60.5836L230.311 60.165",
    stroke: "#263238",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M151.919 87.7675C150.334 87.7203 148.758 88.0188 147.301 88.6422",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M174.3 77.4957C174.3 77.4957 180.063 75.7388 181.598 74.5576",
    stroke: "#263238",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M183.013 73.9738C183.013 73.9738 183.948 73.1514 184.3 73.1514",
    stroke: "#263238",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M218.154 63.5222L217.219 53.9082",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M140.466 95.0952C140.466 95.0952 139.134 100.156 147.637 102.257C151.672 103.252 178.371 109.733 178.371 109.733C178.371 109.733 180.759 104.62 179.396 104.62C178.034 104.62 153.438 88.2471 153.438 88.2471",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_631_68645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 88,
    width: 40,
    height: 22
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M140.468 95.0942C140.468 95.0942 139.136 100.156 147.639 102.256C151.674 103.251 178.373 109.732 178.373 109.732C178.373 109.732 180.761 104.619 179.398 104.619C178.036 104.619 153.44 88.2461 153.44 88.2461",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_631_68645)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M170.034 57.4629L148.185 87.928C148.185 87.928 150.43 90.4325 153.192 92.9295C155.954 95.4265 160.677 97.0264 157.062 96.7946C153.447 96.5629 146.583 93.8042 146.583 93.8042C146.583 93.8042 144.532 95.3966 147.039 96.989C149.547 98.5814 149.996 97.4376 157.279 101.078C164.562 104.719 176.224 107.059 176.224 107.059L175.408 109.018L144.307 101.086C144.307 101.086 138.417 98.3048 140.46 95.105C142.78 91.4342 151.553 79.4052 151.553 79.4052L166.845 59.9674C167.032 59.2606 167.444 58.6338 168.019 58.1819C168.595 57.7301 169.302 57.4776 170.034 57.4629Z",
    fill: "url(#paint9_linear_631_68645)"
  })))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M140.466 95.0952C140.466 95.0952 139.134 100.156 147.637 102.257C151.672 103.252 178.371 109.733 178.371 109.733C178.371 109.733 180.759 104.62 179.396 104.62C178.034 104.62 153.438 88.2471 153.438 88.2471",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M179.396 104.648C179.396 104.648 188.161 108.745 188.842 109.881C189.523 111.018 191.088 116.931 191.088 118.748C191.088 120.564 190.863 120.564 189.725 120.564C188.588 120.564 185.624 116.243 184.943 115.331C184.262 114.419 182.697 114.419 180.617 113.051C180.037 112.684 179.538 112.202 179.152 111.635C178.766 111.068 178.5 110.428 178.371 109.754L179.396 104.648Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M175.653 108.887L177.016 104.662",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M196.149 64.1509C196.149 64.1509 182.107 56.174 177.077 56.8917C172.047 57.6094 167.721 58.3271 167.721 58.3271L177.07 51.793C181.688 53.976 188.424 58.9102 196.149 64.1509Z",
    fill: "url(#paint10_linear_631_68645)"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M242.113 72.815C242.113 72.815 239.868 80.5452 238.925 85.0907C237.981 89.6362 231.642 107.803 231.642 107.803L237.106 111.212C237.106 111.212 249.172 86.2046 251.447 80.7471C253.723 75.2896 253.041 71.1927 250.766 68.9199",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M242.113 72.815C242.113 72.815 239.868 80.5452 238.925 85.0907C237.981 89.6362 231.642 107.803 231.642 107.803L237.106 111.212C237.106 111.212 249.172 86.2046 251.447 80.7471C253.723 75.2896 253.041 71.1927 250.766 68.9199",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M232.677 105.209C233.088 105.209 238.268 108.065 238.268 108.065L232.677 105.209Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M196.77 64.1512C195.512 63.9418 188.805 59.5384 184.195 55.9798C179.584 52.4212 177.069 51.7932 177.069 51.7932L173.925 53.8865C173.449 52.3564 173.6 50.7005 174.344 49.2812C175.602 46.9786 180.003 44.6759 184.404 43.0013C188.805 41.3266 193.835 39.8613 196.979 39.8613C200.123 39.8613 200.961 41.1173 200.961 42.792C200.961 44.4666 200.961 49.6999 199.913 53.6771C198.865 57.6544 196.77 64.1512 196.77 64.1512Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_631_68645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 39,
    width: 28,
    height: 26
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M196.772 64.1512C195.514 63.9418 188.807 59.5384 184.197 55.9798C179.586 52.4212 177.071 51.7932 177.071 51.7932L173.927 53.8865C173.451 52.3564 173.602 50.7005 174.346 49.2812C175.604 46.9786 180.005 44.6759 184.406 43.0013C188.807 41.3266 193.837 39.8613 196.981 39.8613C200.125 39.8613 200.963 41.1173 200.963 42.792C200.963 44.4666 200.963 49.6999 199.915 53.6771C198.867 57.6544 196.772 64.1512 196.772 64.1512Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_631_68645)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M194.795 42.3121C194.795 42.3121 192.864 48.1136 190.926 49.8555C189.431 51.1121 187.81 52.2119 186.09 53.1375C186.09 53.1375 184.923 49.078 182.018 49.078C179.114 49.078 174.668 50.9844 174.668 50.9844C174.668 50.9844 174.668 49.4368 178.343 47.5005L182.018 45.5717L190.536 42.2822L194.795 42.3121Z",
    fill: "url(#paint11_linear_631_68645)"
  }))))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M196.77 64.1512C195.512 63.9418 188.805 59.5384 184.195 55.9798C179.584 52.4212 177.069 51.7932 177.069 51.7932L173.925 53.8865C173.449 52.3564 173.6 50.7005 174.344 49.2812C175.602 46.9786 180.003 44.6759 184.404 43.0013C188.805 41.3266 193.835 39.8613 196.979 39.8613C200.123 39.8613 200.961 41.1173 200.961 42.792C200.961 44.4666 200.961 49.6999 199.913 53.6771C198.865 57.6544 196.77 64.1512 196.77 64.1512Z",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M178.141 37.5731C180.611 40.2731 182.348 43.5598 183.186 47.1201C184.518 53.0337 193.081 59.9566 195.162 59.9566C197.243 59.9566 197.07 49.819 196.389 46.8659C195.708 43.9129 192.916 35.9807 192.916 35.9807C192.916 35.9807 182.01 30.7475 178.141 37.5731Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_631_68645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 34,
    width: 19,
    height: 26
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M178.141 37.5751C180.611 40.275 182.348 43.5617 183.186 47.1221C184.518 53.0356 193.081 59.9585 195.162 59.9585C197.243 59.9585 197.07 49.8209 196.389 46.8679C195.708 43.9148 192.916 35.9827 192.916 35.9827C192.916 35.9827 182.01 30.7494 178.141 37.5751Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_631_68645)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M194.796 42.3151C194.796 42.3151 192.865 48.1165 190.927 49.8584C189.432 51.1151 187.811 52.2149 186.091 53.1404C186.091 53.1404 184.924 49.0809 182.019 49.0809C179.115 49.0809 174.669 50.9873 174.669 50.9873C174.669 50.9873 174.669 49.4398 178.344 47.5035L182.019 45.5746L190.537 42.2852L194.796 42.3151Z",
    fill: "url(#paint12_linear_631_68645)"
  }))))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M178.141 37.5731C180.611 40.2731 182.348 43.5598 183.186 47.1201C184.518 53.0337 193.081 59.9566 195.162 59.9566C197.243 59.9566 197.07 49.819 196.389 46.8659C195.708 43.9129 192.916 35.9807 192.916 35.9807C192.916 35.9807 182.01 30.7475 178.141 37.5731Z",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M170.923 26.6137C172.528 30.9747 174.512 35.1873 176.851 39.2035C180.317 44.8853 186.986 48.0925 190.699 46.6123C194.411 45.132 196.919 40.3623 195.938 32.9534C195.721 31.3237 194.306 30.6583 193.842 29.2154C192.211 23.9821 190.542 18.9358 189.965 17.0144C189.217 14.5398 183.288 12.0727 177.106 13.7997C170.923 15.5267 169.935 20.6852 170.923 26.6137Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_631_68645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 170,
    y: 13,
    width: 27,
    height: 34
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M170.922 26.6127C172.527 30.9737 174.511 35.1863 176.85 39.2025C180.316 44.8843 186.985 48.0916 190.698 46.6113C194.41 45.131 196.918 40.3613 195.937 32.9525C195.72 31.3227 194.306 30.6573 193.841 29.2144C192.21 23.9812 190.541 18.9348 189.964 17.0134C189.216 14.5388 183.287 12.0717 177.105 13.7987C170.922 15.5257 169.934 20.6842 170.922 26.6127Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_631_68645)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M191.415 22.0844C191.415 22.0844 189.17 23.7515 184.125 22.7871C179.081 21.8228 175.608 22.0396 175.802 23.3702C175.997 24.7009 176.379 26.4577 176.379 26.4577C176.379 26.4577 170.324 21.2247 175.81 19.8342C179.769 18.8101 182.052 20.365 183.018 20.5818C183.983 20.7986 191.415 22.0844 191.415 22.0844Z",
    fill: "url(#paint13_linear_631_68645)"
  })))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M170.923 26.6137C172.528 30.9747 174.512 35.1873 176.851 39.2035C180.317 44.8853 186.986 48.0925 190.699 46.6123C194.411 45.132 196.919 40.3623 195.938 32.9534C195.721 31.3237 194.306 30.6583 193.842 29.2154C192.211 23.9821 190.542 18.9358 189.965 17.0144C189.217 14.5398 183.288 12.0727 177.106 13.7997C170.923 15.5267 169.935 20.6852 170.923 26.6137Z",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M175.371 34.7549C175.371 34.7549 171.419 33.0279 171.172 34.7549C170.925 36.4818 172.669 37.7453 174.383 38.4929C174.809 38.7258 175.295 38.8267 175.779 38.7827C176.263 38.7388 176.723 38.552 177.1 38.2462",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M175.371 34.7549C175.371 34.7549 171.419 33.0279 171.172 34.7549C170.925 36.4818 172.669 37.7453 174.383 38.4929C174.809 38.7258 175.295 38.8267 175.779 38.7827C176.263 38.7388 176.723 38.552 177.1 38.2462",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M191.529 24.9992C191.529 24.9992 187.128 23.9526 189.014 29.8137C189.388 30.9725 191.948 32.3256 191.948 32.3256C191.948 32.3256 191.738 34.2095 190.69 34.4189",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M191.529 24.9992C191.529 24.9992 187.128 23.9526 189.014 29.8137C189.388 30.9725 191.948 32.3256 191.948 32.3256C191.948 32.3256 191.738 34.2095 190.69 34.4189",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M188.425 38.6059C188.425 38.6059 185.281 39.2339 184.023 37.7686L188.425 38.6059Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M188.425 38.6059C188.425 38.6059 185.281 39.2339 184.023 37.7686",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M183.775 28.7653C183.775 28.7653 181.469 27.928 180.212 28.9747C179.539 29.4426 179.018 30.0977 178.715 30.8586",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M183.775 28.7653C183.775 28.7653 181.469 27.928 180.212 28.9747C179.539 29.4426 179.018 30.0977 178.715 30.8586",
    stroke: "#263238",
    strokeWidth: 0.682343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M183.717 32.3486C184.017 33.0439 183.949 33.7318 183.583 33.8888C183.216 34.0458 182.669 33.6196 182.37 32.9243C182.07 32.2289 182.138 31.5486 182.505 31.3841C182.871 31.2196 183.425 31.6607 183.717 32.3486Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M191.253 28.6912C191.545 29.3791 191.485 30.0669 191.111 30.2314C190.736 30.3959 190.197 29.9548 189.92 29.3043C189.643 28.6538 189.688 27.9211 190.063 27.7641C190.437 27.6071 190.953 27.9959 191.253 28.6912Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M174.27 35.7568C174.27 35.7568 176.777 33.9326 176.321 32.3402C175.864 30.7478 174.958 30.7478 175.864 29.8432C176.77 28.9386 177.458 28.4751 177.234 27.1144C177.009 25.7538 173.364 23.4736 174.502 22.1129C175.639 20.7523 175.183 19.1225 184.517 21.4251C193.851 23.7277 199.771 20.0645 197.039 16.6554C194.307 13.2463 192.032 12.7902 192.032 12.7902C192.032 12.7902 197.271 10.51 192.937 8.23728C188.604 5.96455 178.828 5.99446 173.364 10.2857C167.9 14.577 169.038 18.2478 169.038 18.2478C169.038 18.2478 166.044 18.6963 165.849 23.2493C165.654 27.8022 174.27 35.7568 174.27 35.7568Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M174.202 20.2136C174.202 20.2136 174.951 17.9035 178.835 17.9035C182.72 17.9035 186.178 21.178 191.418 20.0192C196.657 18.8604 193.731 15.7803 193.731 15.7803",
    stroke: "white",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M172.473 19.6389C172.473 19.6389 172.847 14.847 177.098 13.7705C181.35 12.694 186.956 14.8171 188.497 14.2414",
    stroke: "white",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M170.349 19.833C170.349 19.833 168.036 19.833 167.842 22.9132C167.741 23.7391 167.847 24.577 168.15 25.352C168.453 26.127 168.944 26.8149 169.578 27.354",
    stroke: "white",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M172.474 21.7617C172.141 21.8804 171.837 22.0693 171.584 22.3156C171.331 22.5618 171.133 22.8596 171.006 23.1887C170.878 23.5179 170.822 23.8706 170.843 24.223C170.864 24.5755 170.96 24.9193 171.126 25.2312",
    stroke: "white",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M170.738 27.9297L171.704 29.283",
    stroke: "white",
    strokeWidth: 0.509883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_631_68645",
    x1: 156.142,
    y1: 269.772,
    x2: 156.142,
    y2: -15.6251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_631_68645",
    x1: 166.706,
    y1: 64.0661,
    x2: 166.706,
    y2: 9.40309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_631_68645",
    x1: 117.69,
    y1: 48.7445,
    x2: 117.69,
    y2: 64.8173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#783BDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239935,
    stopColor: "#8932E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431045,
    stopColor: "#9F26E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640531,
    stopColor: "#A124E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A026E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_631_68645",
    x1: 166.706,
    y1: 123.911,
    x2: 166.706,
    y2: 69.2478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_631_68645",
    x1: 122.252,
    y1: 127.357,
    x2: 122.252,
    y2: 107.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_631_68645",
    x1: 137.922,
    y1: 257.652,
    x2: 137.922,
    y2: 87.4808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_631_68645",
    x1: 230.227,
    y1: 78.5886,
    x2: 230.227,
    y2: 56.9452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_631_68645",
    x1: 194.373,
    y1: 134.219,
    x2: 194.373,
    y2: 70.0556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_631_68645",
    x1: 158.31,
    y1: 117.616,
    x2: 158.31,
    y2: 53.9421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_631_68645",
    x1: 158.127,
    y1: 117.669,
    x2: 158.127,
    y2: 53.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_631_68645",
    x1: 181.935,
    y1: 66.2246,
    x2: 181.935,
    y2: 50.9485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_631_68645",
    x1: 184.732,
    y1: 54.959,
    x2: 184.732,
    y2: 41.5405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_631_68645",
    x1: 184.733,
    y1: 54.9619,
    x2: 184.733,
    y2: 41.5434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_631_68645",
    x1: 182.463,
    y1: 27.6272,
    x2: 182.463,
    y2: 19.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F607FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E211FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B727FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9639F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7E45F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6F4CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A4FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5C6EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2FD6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E5EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_68645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 311.178,
    height: 236.945,
    fill: "white",
    transform: "translate(0.551758 0.150391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckingsm);
export default __webpack_public_path__ + "static/media/checking.sm.e9285fe6fdf0b93a6d83cf75da56ac02.svg";
export { ForwardRef as ReactComponent };